@if (!isAuthPage) {
  <nav class="topnav">
    <a routerLink="/" class="logo">
      <img ngSrc="cuminanza-logo.svg" width="36" height="36" priority alt="Cuminanza" />
      <span>Cuminanza<span class="logo-dot">.</span></span>
    </a>
    <div class="nav-links">
      @for (item of navItems(); track item.id) {
        <a
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: !!item.exact }"
          [class]="item.cssClass"
        >
          <app-nav-icon [name]="item.icon" [size]="18" />
          {{ item.labelKey | translate }}
          @if (item.badge && unreadNachrichten() > 0) {
            <span class="nav-badge">{{ unreadNachrichten() }}</span>
          }
        </a>
      }
    </div>
    <div class="auth-area">
      @if (auth.isLoggedIn()) {
        <span class="user-name">{{ auth.getUser()?.name }}</span>
        <button class="btn btn-outline btn-sm" (click)="logout()">
          {{ 'auth.logout' | translate }}
        </button>
      }
    </div>
  </nav>

  <nav class="bottomnav" [attr.aria-label]="'nav.aria_main' | translate">
    @for (item of navItems(); track item.id) {
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: !!item.exact }"
        [class]="item.cssClass"
        [attr.aria-label]="item.labelKey | translate"
      >
        <app-nav-icon [name]="item.icon" [size]="24" />
        @if (item.badge && unreadNachrichten() > 0) {
          <span class="nav-badge">{{ unreadNachrichten() }}</span>
        }
      </a>
    }
  </nav>
}
<main class="main-content">
  <router-outlet />
</main>
<app-toast />
<app-confirm-snackbar />
